const UserAvatar = (props: any) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_126_24814"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36"
      >
        <circle cx="18" cy="18" r="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_126_24814)">
        <circle cx="18" cy="18" r="18" fill="#F1F1F6" />
        <g clip-path="url(#clip0_126_24814)">
          <mask
            id="mask1_126_24814"
            maskUnits="userSpaceOnUse"
            x="-1"
            y="0"
            width="37"
            height="36"
          >
            <path
              d="M17.8888 36C27.8299 36 35.8888 27.9411 35.8888 18C35.8888 8.05887 27.8299 0 17.8888 0C7.94767 0 -0.111206 8.05887 -0.111206 18C-0.111206 27.9411 7.94767 36 17.8888 36Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_126_24814)">
            <path
              d="M37.5707 -1.68335H-1.79456V37.6819H37.5707V-1.68335Z"
              fill="#EFECF9"
            />
            <path
              d="M12.2814 14.7556C12.2814 14.7556 14.3738 12.083 10.3158 14.3322C6.99376 16.1726 5.13184 19.3622 5.13184 19.3622L10.2467 23.0558C10.2467 23.0558 13.5328 17.889 12.2829 14.7542L12.2814 14.7556Z"
              fill="#74492C"
            />
            <path
              d="M23.1521 14.7556C23.1521 14.7556 21.0598 12.083 25.1177 14.3322C28.4398 16.1726 30.3017 19.3622 30.3017 19.3622L25.1868 23.0558C25.1868 23.0558 21.9007 17.889 23.1506 14.7542L23.1521 14.7556Z"
              fill="#74492C"
            />
            <path
              d="M26.2974 13.9783C26.4266 12.6725 25.748 11.5364 24.7816 11.4408C23.8153 11.3452 22.9272 12.3263 22.798 13.6321C22.6688 14.938 23.3475 16.0741 24.3138 16.1697C25.2801 16.2653 26.1682 15.2842 26.2974 13.9783Z"
              fill="#F0BEBA"
            />
            <path
              d="M11.1038 16.1679C12.0701 16.0723 12.7487 14.9362 12.6195 13.6303C12.4904 12.3245 11.6023 11.3434 10.6359 11.439C9.6696 11.5346 8.99096 12.6707 9.12015 13.9765C9.24934 15.2824 10.1374 16.2635 11.1038 16.1679Z"
              fill="#F0BEBA"
            />
            <path
              d="M13.7214 16.7141H21.735V29.3847C21.735 30.492 20.835 31.392 19.7277 31.392H15.7273C14.62 31.392 13.72 30.492 13.72 29.3847V16.7141H13.7214Z"
              fill="#F2D1D2"
            />
            <path
              d="M21.7365 24.8068C21.7365 24.8068 19.2266 25.0804 16.9341 24.1516C14.9944 23.3668 13.7214 21.3134 13.7214 21.3134V18.802H21.735V24.8068H21.7365Z"
              fill="#F0BEBA"
            />
            <path
              d="M17.716 3.95557C14.0123 3.95557 10.9811 6.98677 10.9811 10.6904V16.0357C10.9811 19.7394 13.995 22.7706 17.716 22.7706C21.4369 22.7706 24.4508 19.7394 24.4508 16.0357V10.6904C24.4508 6.98677 21.4196 3.95557 17.716 3.95557Z"
              fill="#F2D1D2"
            />
            <path
              d="M17.5144 14.4907C17.5144 14.4907 17.068 15.0739 17.5158 15.6946"
              stroke="#E78990"
              stroke-width="0.724832"
              stroke-miterlimit="10"
              stroke-linecap="round"
            />
            <path
              d="M13.2722 12.8375C13.1685 12.9138 13.7906 12.6229 14.4703 12.6042C15.3213 12.5811 15.6367 12.8303 15.7029 12.7079C15.7937 12.5408 15.0809 12.3594 14.4271 12.4386C13.8079 12.512 13.4537 12.7021 13.2708 12.8375H13.2722Z"
              fill="#141418"
              stroke="#141418"
              stroke-width="0.454228"
              stroke-miterlimit="10"
            />
            <path
              d="M22.1599 12.8375C22.2636 12.9138 21.6415 12.6229 20.9618 12.6042C20.1108 12.5811 19.7954 12.8303 19.7292 12.7079C19.6384 12.5408 20.3512 12.3594 21.005 12.4386C21.6242 12.512 21.9784 12.7021 22.1613 12.8375H22.1599Z"
              fill="#141418"
              stroke="#141418"
              stroke-width="0.454228"
              stroke-miterlimit="10"
            />
            <path
              d="M9.16097 9.99637C9.16961 10.7408 9.25745 11.6898 10.1978 12.7252C10.7378 13.3199 11.7602 13.4826 11.8984 11.972C12.0727 10.0669 16.1911 9.60037 17.0579 7.54405C17.6008 6.25813 17.4727 4.99813 15.5344 4.98517C10.8458 4.95061 9.13649 7.88101 9.15953 9.99781L9.16097 9.99637Z"
              fill="#F0BEBA"
            />
            <path
              d="M25.6965 9.99657C25.6878 10.7411 25.6 11.69 24.6597 12.7254C24.1197 13.3201 17.6742 11.1961 16.1104 7.71562C15.5373 6.43834 15.4307 4.57354 17.3603 4.41082C23.8691 3.86506 25.7195 7.87977 25.6965 9.99657Z"
              fill="#F0BEBA"
            />
            <g>
              <path
                d="M15.3156 14.5211C15.3156 15.002 15.0737 15.3174 14.7756 15.3174C14.4775 15.3174 14.2356 15.0006 14.2356 14.5211C14.2356 14.0416 14.4775 13.804 14.7756 13.804C15.0737 13.804 15.3156 14.0416 15.3156 14.5211Z"
                fill="#232323"
              />
            </g>
            <g>
              <path
                d="M20.1179 14.5211C20.1179 15.002 20.3598 15.3174 20.6579 15.3174C20.956 15.3174 21.1979 15.0006 21.1979 14.5211C21.1979 14.0401 20.956 13.804 20.6579 13.804C20.3598 13.804 20.1179 14.0416 20.1179 14.5211Z"
                fill="#232323"
              />
            </g>
            <g opacity="0.3">
              <path
                d="M14.2817 15.6946C14.2817 16.2662 13.7719 16.7285 12.882 16.7285C11.9921 16.7285 11.4823 16.2648 11.4823 15.6946C11.4823 15.1243 11.9921 14.6606 12.882 14.6606C13.7719 14.6606 14.2817 15.1243 14.2817 15.6946Z"
                fill="#E78990"
              />
              <path
                d="M21.1519 15.6946C21.1519 16.2662 21.6616 16.7285 22.5515 16.7285C23.4415 16.7285 23.9512 16.2648 23.9512 15.6946C23.9512 15.1243 23.4415 14.6606 22.5515 14.6606C21.6616 14.6606 21.1519 15.1243 21.1519 15.6946Z"
                fill="#E78990"
              />
            </g>
            <path
              d="M8.95081 9.13823C8.95945 10.0699 9.05017 11.2579 10.0279 12.5539C10.5895 13.2969 11.6508 13.5014 11.7948 11.6107C11.9748 9.22607 16.2531 8.64143 17.1545 6.06815C17.7175 4.45823 17.5851 2.88287 15.5719 2.86415C10.7019 2.82095 8.92633 6.48863 8.95081 9.13823Z"
              fill="#74492C"
            />
            <path
              d="M26.127 9.13824C26.1184 10.0699 26.0277 11.2579 25.0499 12.5539C24.4883 13.297 17.7938 10.6402 16.1709 6.28272C15.5747 4.68432 15.4653 2.34864 17.4683 2.14704C24.2291 1.46304 26.1515 6.49008 26.127 9.13824Z"
              fill="#74492C"
            />
            <path
              d="M19.2453 17.8544C19.2453 18.5831 18.5656 19.1749 17.729 19.1749C16.8923 19.1749 16.2126 18.5845 16.2126 17.8544C16.2126 17.1244 16.8923 17.3476 17.729 17.3476C18.5656 17.3476 19.2453 17.1244 19.2453 17.8544Z"
              fill="#E78990"
            />
            <path
              d="M27.8838 26.9943C27.1379 25.8697 24.0952 25.6465 21.6011 25.3757C21.0669 26.99 19.8803 28.178 17.8873 28.178C15.7806 28.178 14.2398 26.522 13.7531 24.9797C11.2835 25.2548 8.52734 25.8841 7.7915 26.9943C4.8251 31.4713 8.17166 46.5365 9.82046 52.6277C10.1661 53.9036 10.2568 53.8633 11.3541 53.9482C15.0102 54.2319 20.4433 54.373 24.1801 54.1023C25.3523 54.0173 25.3998 53.9237 25.7843 52.5615C27.6289 46.0441 30.8488 31.4698 27.8838 26.9943Z"
              fill="white"
            />
            <path
              d="M8.51447 26.3333C4.85111 27.216 4.61927 29.2838 -1.22713 46.9497C-4.61545 57.1867 -5.68969 59.9011 -6.07993 61.2878C-6.12745 61.4577 -6.03817 61.6363 -5.87401 61.6997L-1.41865 63.4133C-1.24729 63.4795 -1.05433 63.3989 -0.982326 63.2304L11.2764 36.7517L8.51447 26.3347V26.3333Z"
              fill="#BFAAFC"
            />
            <path
              d="M27.0069 26.4426C30.6702 27.3253 30.7293 29.2837 36.5771 46.9482C39.9654 57.1852 41.0397 59.8996 41.4299 61.2863C41.4774 61.4562 41.3882 61.6348 41.224 61.6981L36.7686 63.4117C36.5973 63.478 36.4043 63.3973 36.3323 63.2289L24.0736 36.7501L27.0083 26.4426H27.0069Z"
              fill="#BFAAFC"
            />
            <path
              d="M10.3403 29.7935H25.4373"
              stroke="#6725EC"
              stroke-width="0.717584"
              stroke-miterlimit="10"
            />
            <path
              d="M10.3403 31.9924H25.4373"
              stroke="#6725EC"
              stroke-width="0.717584"
              stroke-miterlimit="10"
            />
            <path
              d="M10.3403 34.1929H25.4373"
              stroke="#6725EC"
              stroke-width="0.717584"
              stroke-miterlimit="10"
            />
            <path
              d="M13.383 24.4727L14.2355 43.9112H9.65919L8.06079 26.5376C8.06079 26.5376 10.8458 24.7218 13.383 24.4727Z"
              fill="#BFAAFC"
            />
            <path
              d="M22.3946 24.4727L21.5421 43.9112H26.1184L27.7168 26.5376C27.7168 26.5376 24.9319 24.7218 22.3946 24.4727Z"
              fill="#BFAAFC"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_126_24814">
          <rect
            width="36"
            height="36"
            fill="white"
            transform="translate(-0.111206)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserAvatar;
